import React from 'react';
import PropTypes from 'prop-types';
import { isPresent } from 'utils/helperMethods';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import Avatar from 'sharedComponents/Avatar';
import Tag from 'sharedComponents/Tag';
import LoanOfficerPresenter from 'presenters/realEstateAgent/LoanOfficerPresenter';

import { Typography, Button } from '@material-ui/core';

import useStyles from './useStyles';

const LoanOfficerCard = props => {
  const { loanOfficer, onAdd, isAdding, isFavorite } = props;
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();

  const isCompanyLogotypePresent = isPresent(LoanOfficerPresenter.companyLogoUrl(loanOfficer));
  const apr = LoanOfficerPresenter.readableApr(loanOfficer);
  const responseTime = LoanOfficerPresenter.readableResponseTime(loanOfficer);
  const isAprPresent = isPresent(apr);
  const isResponseTimePresent = isPresent(responseTime);

  const handleAdd = () => {
    onAdd(LoanOfficerPresenter.loanOfficerId(loanOfficer));
  };

  return (
    <div className={classes.container}>
      <div className={classes.mainBox}>
        <Avatar size="m" imageUrl={LoanOfficerPresenter.profileImageUrl(loanOfficer)} />
        <div className={classes.loanOfficerBadge}>
          <Typography noWrap variant="subtitle1" color="secondary">
            {t('models.App.userTypes.loanOfficer')}
          </Typography>
          <Typography noWrap variant="h3" className={classes.name}>
            {LoanOfficerPresenter.loanOfficerName(loanOfficer)}
          </Typography>
        </div>
        {isDesktop && (
          <div className={classes.infoBox}>
            <div className={classes.logoBox}>
              {isCompanyLogotypePresent && (
                <img
                  alt="company logo"
                  src={LoanOfficerPresenter.companyLogoUrl(loanOfficer)}
                  className={classes.companyLogo}
                />
              )}
            </div>
            <div className={classes.locationBadge}>
              <Typography variant="subtitle1" color="secondary">
                {t('components.RealEstateAgentLoanOfficers.LoanOfficersList.LoanOfficerCard.branchLocation')}
              </Typography>
              <Typography noWrap variant="h3" color="inherit" className={classes.label}>
                {LoanOfficerPresenter.branchLocation(loanOfficer)}
              </Typography>
            </div>
            {isAprPresent && (
              <Tag className={classes.tag} color="red">
                <Typography
                  noWrap
                  variant="subtitle1"
                  dangerouslySetInnerHTML={{
                    __html: t('components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.apr', {
                      apr,
                    }),
                  }}
                />
              </Tag>
            )}
            {isResponseTimePresent && (
              <Tag className={classes.tag}>
                <Typography
                  noWrap
                  variant="subtitle1"
                  dangerouslySetInnerHTML={{
                    __html: t(
                      'components.RealEstateAgentLoanOfficers.WaitlistLoanOfficersList.LoanOfficerCard.responseTime',
                      { responseTime },
                    ),
                  }}
                />
              </Tag>
            )}
          </div>
        )}
      </div>
      {isFavorite ? (
        <Typography variant="subtitle1" color="secondary">
          {t('components.RealEstateAgentLoanOfficers.LoanOfficersList.LoanOfficerCard.favorite')}
        </Typography>
      ) : (
        <Button onClick={handleAdd} disabled={isAdding}>
          {t('components.RealEstateAgentLoanOfficers.LoanOfficersList.LoanOfficerCard.add')}
        </Button>
      )}
    </div>
  );
};

LoanOfficerCard.propTypes = {
  loanOfficer: LoanOfficerPresenter.shape().isRequired,
  onAdd: PropTypes.func.isRequired,
  isAdding: PropTypes.bool.isRequired,
  isFavorite: PropTypes.bool.isRequired,
};

export default LoanOfficerCard;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/LoanOfficersList/components/LoanOfficerCard/LoanOfficerCard.js